import { versionService } from '@/services/version.service';
import { useIntervalFn } from '@vueuse/core';
import { type MaybeRefOrGetter, toValue } from 'vue';

const VERSION_CHECK_INTERVAL_MS = 10_000;

export function useAutoReloadOnAppUpdate(enabled: MaybeRefOrGetter<boolean> = true) {
  useIntervalFn(
    async () => {
      if (!toValue(enabled)) return;

      if (await versionService.checkForUpdates()) {
        window.location.reload();
      }
    },
    VERSION_CHECK_INTERVAL_MS,
    { immediateCallback: true },
  );
}
